export default __webpack_public_path__ + "img/99c742b62224ac5fe046de27439ad4d3.png";